import type { FC } from "react";
import { getIsWeb } from "../../@api/config";
import { getHideNavigation } from "../../store/hideNavigation/hideNavigation";
import { styled, useIsDarkMode } from "@kivra/react-components";
import { SmartBanner } from "../atoms/SmartBanner";
import { Banners } from "./Banners";
import { BannersMobile } from "./BannersMobile";

interface LayoutProps {
  children?: React.ReactNode;
}

export const Layout: FC<LayoutProps> = ({ children }) => {
  const isDarkMode = useIsDarkMode();
  const isNative = getHideNavigation() || !getIsWeb(); // native app

  return (
    <LayoutContainer>
      <SmartBanner />
      <MainContainer>
        <TopContainer>{children}</TopContainer>
        {!isNative && (
          <>
            <MobileBannerContainer isDarkMode={isDarkMode}>
              <BannersMobile />
            </MobileBannerContainer>
          </>
        )}
      </MainContainer>
      <BannerContainer isDarkMode={isDarkMode}>
        <Banners />
      </BannerContainer>
    </LayoutContainer>
  );
};

const LayoutContainer = styled.div({
  display: "grid",
  gridTemplateColumns: "594px 1fr",
  gridTemplateAreas: '"main banner"',
  minHeight: "calc(100vh - 64px)",
  $medium: {
    gridTemplateColumns: "1fr 1fr",
    minHeight: "calc(100vh - 55px)",
  },
  $small: {
    gridTemplateColumns: "1fr",
    gridTemplateAreas: "main",
    minHeight: "calc(100vh - 55px)",
  },
});

const MainContainer = styled.div({
  position: "relative",
  gridArea: "main",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: ["$spacing-20", "$spacing-0"],
  "@media (max-width: 992px)": {
    padding: 0,
    maxWidth: "100%",
  },
});

const BannerContainer = styled.div<{ isDarkMode: boolean }>(
  ({ isDarkMode }) => ({
    gridArea: "banner",
    display: "flex",
    width: "100%",
    padding: ["$spacing-20", "$spacing-0"],
    justifySelf: "center",
    flexDirection: "column",
    alignItems: "center",
    backgroundImage: isDarkMode
      ? `linear-gradient(
                90deg,
                rgb(0, 0, 0) 0%,
                rgb(3, 46, 129) 45.61%
            )`
      : "linear-gradient(270deg, #EDF9E1 33.14%, #F8F6F3 99.65%);",
    $small: {
      display: "none",
    },
  }),
);

const TopContainer = styled("div")({
  maxWidth: "343px",
});

const MobileBannerContainer = styled.div<{ isDarkMode: boolean }>(
  ({ isDarkMode }) => ({
    width: "100%",
    display: "none",
    $small: {
      display: "block",
    },
    backgroundImage: isDarkMode
      ? `linear-gradient(
                186deg,
                rgb(0, 0, 0) 0%,
                rgb(3, 46, 129) 45.61%
            );`
      : "linear-gradient(0deg, #EDF9E1 33.14%, #F8F6F3 99.65%);",
  }),
);
